// extracted by mini-css-extract-plugin
module.exports = {"container":"DealerInformation-module--container--2lgyF","dealerItem":"DealerInformation-module--dealerItem--1VLZF","description":"DealerInformation-module--description--2kjyh"};